if (window.location.href.indexOf("products") > -1) {

  console.log('Form submission code loaded.')
  
  let initiallyDisabled = false
  
  // document.querySelectorAll(`variant-radios input[type="radio"]:checked`).forEach(radio => {
  //     if(!initiallyDisabled) initiallyDisabled = radio.classList.contains("disabled")
  // })

  initiallyDisabled = !!document.querySelector(`button.product-form__submit`).disabled

  console.log(initiallyDisabled)
  
  document.querySelector(".product-form__quantity").classList.toggle("inactive", initiallyDisabled)
  document.querySelector("product-form").classList.toggle("inactive", initiallyDisabled)
  document.querySelector(".sold-out-form").classList.toggle("active", initiallyDisabled)
  
  document.querySelectorAll(`variant-radios label`).forEach(label => {
      label.addEventListener("click", e => {
          let target = e.target.getAttribute("for")
          let input = document.querySelector(`input#${target}`)
          const disabled = input.classList ? input.classList.contains("disabled") : false
  
          document.querySelector(".product-form__quantity").classList.toggle("inactive", disabled)
          document.querySelector("product-form").classList.toggle("inactive", disabled)
          document.querySelector(".sold-out-form").classList.toggle("active", disabled)
      })
  })
  
  document.querySelector("#sold-out-notification").addEventListener("submit", e => {
      e.preventDefault()
  
      const formData = new FormData(e.target)
  
      document.querySelectorAll(`variant-radios fieldset`).forEach(fieldset => {
          const label = fieldset.querySelector(".form__label").innerHTML
          const value = document.querySelector("variant-radios input:checked").value
          formData.append(label, value)
      })
  
      formData.append("Product", document.querySelector(".product__title h1").innerHTML)
  
      fetch("https://hook.eu1.make.com/atdov7e1ow6ngnwbmwo2hoysl5159sbk", {
          method: "POST",
          body: formData
      })
      .then(res => {
          document.querySelector(".sold-out-form .thanks").classList.remove("hide")
      })
  })

}